export default "__VITE_ASSET__DM50kxgr__"